<div
  class="image-tile hover-opacity"
  (click)="onFilterClick()"
  [reactComponent]="imageTileComponent"
  [props]="{
    checked: discoverFilter.active,
    disabled: this.disabled,
    imgUrl: imageUrl,
    altText: this.altText
  }"
></div>
